//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel
} from '@mui/material';

// === API ===
import { onCorrectionMode, removeListener, requestCorrectionMode, setCorrectionModeAll, setCorrectionModeExceptions, setCorrectionModeHybrid } from 'api/prokey/prokey.websocket';
import { actions as modeActions } from 'store/modules/correctionMode';

//#endregion

//-----------------------------------------------------------------
export function ModeSelect() {
  //-----------------------------------------------------------------
  
  //#region [VALUES]

  const mode_values = {
    'CORRECT-ALL'        : 1,
    'CORRECT-EXCEPTIONS' : 2,
    'CORRECT-HYBRID'     : 3,
  }

  const [ mode, setMode ] = useState( mode_values['CORRECT-EXCEPTIONS'] );
  const dispatch = useDispatch();

  //#endregion

  //#region [STYLES]
  
    const _styles = {
      drop_down: {
        labelId: 'mode-select-label',
        id: 'mode-select',
        label: 'Correction Mode',
        height: '100%',
        minWidth: '8rem',
        marginLeft: '1rem',
        marginRight: '1rem',
      }
    }

    const DROP_DOWN = {
      sx : _styles.drop_down,
      size: 'small',
      name:'correction_mode_select'
    }
  
  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleCorrectionMode(data) {
      //-----------------------------------------------------------------
      setMode( mode_values[data] );
      updateClientMode(data);
    }

    onCorrectionMode( handleCorrectionMode );
    requestCorrectionMode();

    return () => {
      removeListener( 'CORRECTION-MODE', handleCorrectionMode );
    };
  }, [] )

  //#endregion

    //#region [EVENTS]

  //-----------------------------------------------------------------
  function handleChange(e) {
    //-----------------------------------------------------------------
    e.preventDefault();
    const item = e.target.value
    
    if (item === 1) { 
      setCorrectionModeAll();
      setMode( mode_values['CORRECT-ALL'] );
      updateClientMode('CORRECT-ALL');
    
    }
    if (item === 2) {
      setCorrectionModeExceptions();
      setMode( mode_values['CORRECT-EXCEPTIONS'] );
      updateClientMode('CORRECT-EXCEPTIONS');
    }
    if (item === 3) {
      setCorrectionModeHybrid();
      setMode( mode_values['CORRECT-HYBRID'] );
      updateClientMode('CORRECT-HYBRID');
    }
  }

  function updateClientMode(value) {
    localStorage.setItem('correct-mode', value);
    if( value === 'CORRECT-ALL' ) dispatch(modeActions.correctAll());
    if( value === 'CORRECT-EXCEPTIONS' ) dispatch(modeActions.correctExceptions());
    if( value === 'CORRECT-HYBRID' ) dispatch(modeActions.correctHybrid());
  }

    //#endregion
  
    //#region [DISPLAY]
  
    //-----------------------------------------------------------------
    function display() {
      //-----------------------------------------------------------------
      return (
        <FormControl variant = 'standard' >
          <InputLabel sx={{marginLeft: '1rem'}} id = 'mode-select-label'>Correction Mode</InputLabel>
          <Select key={0} {...DROP_DOWN} value={mode} onChange={handleChange}>
            <MenuItem value={1}> { 'All'        } </MenuItem>
            <MenuItem value={2}> { 'Exceptions' } </MenuItem>
            <MenuItem value={3}> { 'Hybrid'     } </MenuItem>
          </Select>
        </FormControl>
      );
    }
  
    //#endregion
  
    return display();
  }
